import { Download } from '@mui/icons-material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import {
  Alert,
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  MenuItem,
  Select,
  Snackbar,
  TextField,
  Typography,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import { ComponentType, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Commission } from 'src/components/commissions';
import { _Locale } from 'src/components/commissions/BasicTable';
import { SearchIcon } from 'src/components/icons';
import { AUTH_TOKEN_KEY } from 'src/constants/base';
import { ApplicationStatus } from 'src/enums/application-status.enum';
import { Roles } from 'src/enums/roles.enum';
import { useAuth } from 'src/hooks';
import { ApiApplication, ApiCommission, ApiRegion, ApiSpecialities } from 'src/http';
// import { REACT_APP_API_BASE_URL } from '../../../constants/base';
import CachedIcon from '@mui/icons-material/Cached';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs, { Dayjs } from 'dayjs';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Page } from '../../page';
import { Region, Speciality } from '../applications-user';
import { Application } from '../applications-user/BasicTable';
import InputFileUpload from '../applications-user/InputFile';
import BasicTable from './BasicTable';

// const BASE_URL = REACT_APP_API_BASE_URL;
interface changeStatusProps {
  item: Application;
  status: ApplicationStatus;
  message: string;
  isPrimary: string | undefined;
  prematureRecipient: string | undefined;
}

const ApplicationSteps = {
  zero: '0',
  one: '1',
  two: '2',
  three: '3',
  four: '4',
};
interface Exam {
  examPlace: string;
  examDate: string;
  type: string;
  applications: string;
}
const _defaultExam = {
  examPlace: '',
  examDate: '',
  type: 'TEST',
  applications: '',
};

export const ApplicationsAdmin: ComponentType = () => {
  const { t, i18n } = useTranslation();
  const { user } = useAuth();
  const [total, setTotal] = useState<number>(0);

  let temp = Object.keys(ApplicationStatus);

  const [allStatuses, setAllStatuses] = useState<string[]>([]);

  useEffect(() => {
    if (user?.data?.role !== 'SUPER_ADMIN') {
      setAllStatuses(
        temp.filter(
          (f) => f !== 'APPEAL_PENDING' && f !== 'APPEAL_DECLINED' && f !== 'APPEAL_CONFIRMED'
        )
      );
    } else {
      setAllStatuses(Object.keys(ApplicationStatus));
    }
  }, []);

  const [commissions, setCommissions] = useState<Commission[] | null>(null);
  const getCommissions = async (type?: string) => {
    let params = {
      skip: 0,
      take: 999,
      appType: type ? type : activeAppType,
    };
    try {
      const data = await ApiCommission.fetchAll(params);
      const temp = data.hits.sort((a: any, b: any) => Number(a.publicId) - Number(b.publicId));
      setCommissions(temp);
    } catch ({ message }: any) {
      console.log(message);
    }
  };

  const [specialities, setSpecialities] = useState<Speciality[] | null>(null);
  const getSpecialities = async () => {
    let params = {
      skip: 0,
      take: 999,
    };
    try {
      const data = await ApiSpecialities.fetchAll(params);
      setSpecialities(data.hits);
    } catch ({ message }: any) {
      console.log(message);
    }
  };

  const [regions, setRegions] = useState<Region[] | null>(null);
  const getRegions = async () => {
    let params = {
      skip: 0,
      take: 100,
    };
    try {
      const data = await ApiRegion.fetchAll(params);
      setRegions(data.hits);
    } catch ({ message }: any) {
      console.log(message);
    }
  };

  useEffect(() => {
    getCommissions();
    getSpecialities();
    getRegions();
  }, []);

  const [applications, setApplications] = useState<Application[] | null>(null);
  const [activeStatus, setActiveStatus] = useState<string>(
    localStorage.getItem('status') || ApplicationStatus.PENDING
  );
  const [activeCommission, setActiveCommission] = useState(
    localStorage.getItem('commission') || '0'
  );
  const [activeRegion, setActiveRegion] = useState(localStorage.getItem('region') || '0');
  const [activeAppType, setActiveAppType] = useState<string>(
    localStorage.getItem('appType') || '1'
  );
  const [activeStep, setActiveStep] = useState<string | null>(localStorage.getItem('step') || '5');
  const params: any = {
    status: localStorage.getItem('status') || ApplicationStatus.PENDING,
    embed: 'user',
    appType: localStorage.getItem('appType') || '1',
    skip: 0,
    take: 10,
    order: '-createdAt',
    commission: localStorage.getItem('commission') || '0',
    region: localStorage.getItem('region') || '0',
    steps: localStorage.getItem('step') || '5',
  };

  const getApplications = async (_params?: any) => {
    let temp = _params ? _params : params;
    try {
      if (temp.commission === '0') {
        delete temp.commission;
      }
      if (temp.region === '0') {
        delete temp.region;
      }
      if (search !== '') {
        temp.search = search;
      }
      if (temp.steps === '5') {
        delete temp.steps;
      }
      if (checked) {
        temp.appFrom = 'mygov.uz';
      }
      const data = await ApiApplication.fetchAll(temp);
      setApplications(data.hits);
      setTotal(Math.ceil(data.total / 10));
    } catch ({ message }: any) {
      console.log(message);
    }
  };

  useEffect(() => {
    setStatus(ApplicationStatus.PENDING);
  }, []);

  const changePagination = (_page: number) => {
    params.skip = _page ? (_page - 1) * 10 : 0;
    getApplications(params);
  };

  const setStatus = (status: string) => {
    localStorage.setItem('status', status);
    setActiveStatus(status);
    params.status = status;
    params.skip = 0;
    getApplications(params);
  };

  const setAppType = (type: string) => {
    setActiveAppType(type);
    localStorage.setItem('appType', type);

    getCommissions(type);
    setActiveCommission('0');
    localStorage.setItem('commission', '0');

    params.appType = type;
    params.skip = 0;
    getApplications(params);
  };

  const setCommission = (com: string) => {
    localStorage.setItem('commission', com);
    setActiveCommission(com);
    params.commission = com;
    params.skip = 0;
    getApplications(params);
  };

  const setRegion = (reg: string) => {
    localStorage.setItem('region', reg);
    setActiveRegion(reg);
    params.region = reg;
    params.skip = 0;
    getApplications(params);
  };
  const setStep = (step: string) => {
    localStorage.setItem('step', step);
    setActiveStep(step);
    params.steps = step;
    params.skip = 0;
    getApplications(params);
  };

  const onDownloadCertificates = async () => {
    const token = localStorage.getItem(AUTH_TOKEN_KEY);
    let url = `https://tibtoifa.ssv.uz/api/v1/applications/download?appType=${activeAppType}`;
    url =
      activeCommission && activeCommission !== '0' ? url + `&commission=${activeCommission}` : url;
    url = activeRegion && activeRegion !== '0' ? url + `&region=${activeRegion}` : url;
    fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.blob())
      .then((myBlob) => {
        const url = window.URL.createObjectURL(myBlob);
        const link = document.createElement('a');
        link.href = url;
        let today: Date | string = new Date();
        let dd = String(today.getDate()).padStart(2, '0');
        let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        let yyyy = today.getFullYear();
        today = mm + '_' + dd + '_' + yyyy;
        link.setAttribute('download', today + '.xlsx'); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
  };
  // TEST_TAKERS
  const onDownload_STATUS_RESULTS = async () => {
    const token = localStorage.getItem(AUTH_TOKEN_KEY);
    //  https://tibtoifa.ssv.uz/api/v1/applications/download-app-with-status?status={STATUS_NAME}
    let url = `https://tibtoifa.ssv.uz/api/v1/applications/download-app-with-status?appType=${activeAppType}&status=${activeStatus}`;

    url =
      activeCommission && activeCommission !== '0' ? url + `&commission=${activeCommission}` : url;
    url = activeRegion && activeRegion !== '0' ? url + `&region=${activeRegion}` : url;
    fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.blob())
      .then((myBlob) => {
        const url = window.URL.createObjectURL(myBlob);
        const link = document.createElement('a');
        link.href = url;
        let today: Date | string = new Date();
        let dd = String(today.getDate()).padStart(2, '0');
        let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        let yyyy = today.getFullYear();
        today = mm + '_' + dd + '_' + yyyy;
        link.setAttribute('download', today + '.xlsx'); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
  };

  const onDownload_STATUS_CSV = async () => {
    const token = localStorage.getItem(AUTH_TOKEN_KEY);
    let url = `https://tibtoifa.ssv.uz/api/v1/applications/download-app-with-status-csv?appType=${activeAppType}&status=${activeStatus}`;

    url =
      activeCommission && activeCommission !== '0' ? url + `&commission=${activeCommission}` : url;
    url = activeRegion && activeRegion !== '0' ? url + `&region=${activeRegion}` : url;
    fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.blob())
      .then((myBlob) => {
        const url = window.URL.createObjectURL(myBlob);
        const link = document.createElement('a');
        link.href = url;
        let today: Date | string = new Date();
        let dd = String(today.getDate()).padStart(2, '0');
        let mm = String(today.getMonth() + 1).padStart(2, '0');
        let yyyy = today.getFullYear();
        today = mm + '_' + dd + '_' + yyyy;
        link.setAttribute('download', today + '.csv');
        document.body.appendChild(link);
        link.click();
      });
  };
  // Search
  const [search, setSearch] = useState<string>('');
  const Steps = () => {
    let temp = [];
    for (let index = 0; index < Object.entries(ApplicationSteps).length; index++) {
      temp.push(
        <MenuItem value={Object.entries(ApplicationSteps)[index][1]} key={index}>
          {t('ApplicationStep.' + Object.entries(ApplicationSteps)[index][0])}
        </MenuItem>
      );
    }
    return (
      <Select
        required
        labelId="demo-simple-select1-label"
        id="demo-simple-select1"
        value={activeStep}
        label="Age"
        sx={{ maxWidth: 500 }}
        onChange={(e: any) => {
          setStep(e.target.value);
        }}
      >
        <MenuItem value={'5'}>{t('action.select')}</MenuItem>
        {temp}
      </Select>
    );
  };

  // CHANGE STATUS
  const createItem = async (props: changeStatusProps) => {
    const { status, item, message, isPrimary, prematureRecipient } = props;
    if (item?.id && status !== item.status) {
      try {
        if (item.status === ApplicationStatus.PENDING) {
          await ApiApplication.changeStatus(
            item.id,
            status.toString(),
            message,
            isPrimary,
            prematureRecipient
          );
        } else if (item.status === ApplicationStatus.CONFIRMED) {
          await ApiApplication.changeStatus(item.id, status.toString(), message, isPrimary);
        } else {
          await ApiApplication.changeStatus(item.id, status.toString(), message);
        }
        setStatus(status);
      } catch ({ message }: any) {
        console.log(message);
      }
    }
  };

  const [checked, setChecked] = useState<boolean>(false);
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  };
  useEffect(() => {
    getApplications(params);
  }, [checked]);

  // const [taskID, setTaskID] = useState<string>('');
  const getMyGovApplication = async () => {
    try {
      await ApiApplication.getMyGovApplication();
      setError('');
      setSnackOpen(true);
    } catch (error) {
      console.log(error);
      setError('Serverda xatolik');
      setSnackOpen(true);
    }
  };
  // MODAL
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const [value, setValue] = useState<Dayjs | null>(dayjs(new Date()));
  const [exam, setExam] = useState<Exam>({ ..._defaultExam });
  const [examPlace, setExamPlace] = useState('');
  const handleClose = () => {
    setOpen(false);
    setError('');
    setExam({ ..._defaultExam });
    setValue(dayjs(new Date()));
    setExamPlace('');
  };

  const [examType, setExamType] = useState<string>('1');
  const [testResult, setTestResult] = useState<string>('');
  const [loading, setLoading] = useState(false);
  const handleExamInformation = async () => {
    const temp: number[] = [];
    exam.applications
      .replace(/ /g, '')
      .split(',')
      .map((n) => temp.push(Number(n)));
    try {
      setLoading(true);

      if (examType === '1') {
        await ApiApplication.examdates({
          ...exam,
          examPlace: examPlace,
          examDate: value,
          applications: temp,
        });
      } else if (examType === '2') {
        await ApiApplication.examdatesResults({
          testResult,
          applications: temp,
        });
      } else if (examType === '3') {
        await ApiApplication.examdatesOral({
          interviewDay: value,
          interviewPlace: examPlace,
          type: 'ORAL',
          applications: temp,
        });
      } else if (examType === '4') {
        await ApiApplication.examdatesOral_SECOND({
          interviewDay: value,
          interviewPlace: examPlace,
          type: 'ORAL',
          applications: temp,
        });
      }
      handleClose();
      setSnackOpen(true);
    } catch ({ message }: any) {
      setError(message);
      setSnackOpen(true);
    }finally {
      setLoading(false);
    }
  };

  // SNACK
  const [snackOpen, setSnackOpen] = useState(false);
  const [error, setError] = useState('');
  const handleCloseSnack = () => {
    setSnackOpen(false);
  };

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={snackOpen}
        autoHideDuration={6000}
        onClose={handleCloseSnack}
      >
        {error ? (
          <Alert onClose={handleCloseSnack} severity="error" sx={{ width: '100%' }}>
            <div> Ma'lumotlar yuklanmadi. Iltimos qaytadan urinib ko'ring! </div>
          </Alert>
        ) : (
          <Alert onClose={handleCloseSnack} severity="success" sx={{ width: '100%' }}>
            Ma'lumotlar yuklandi
          </Alert>
        )}
      </Snackbar>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" sx={{ p: 0, mb: 2, fontSize: 18 }}>
          {"Imtihon ma'lumotlarini kiriting"}
        </DialogTitle>
        <Box display={'flex'} alignItems={'center'} my={2}>
          <Typography mr={2}>{t('Imtixon turi')}</Typography>
          <Select
            required
            labelId="demo-simple-select2-label"
            id="demo-simple-select2"
            value={examType}
            label="Age"
            sx={{ maxWidth: 500 }}
            onChange={(e: any) => {
              setExamType(e.target.value);
            }}
          >
            <MenuItem value="1">{t('Test sanasini yuborish')}</MenuItem>
            <MenuItem value="2">{t('Test natijasini yuborish')}</MenuItem>
            <MenuItem value="3">{t("Og'zaki imtihon sanalarini 1-marta yuborish")}</MenuItem>
            <MenuItem value="4">{t("Og'zaki imtihon sanalarini 2-marta yuborish")}</MenuItem>
          </Select>
        </Box>
        {examType !== '2' && (
          <Box mb={4} mx={4}>
            <ReactQuill theme="snow" value={examPlace} onChange={setExamPlace} />
          </Box>
          // <TextField
          //   id="outlined-multiline-static1"
          //   placeholder={t("O'tkazilish manzili")}
          //   value={exam.examPlace || ''}
          //   fullWidth
          //   size="medium"
          //   onChange={(e) => {
          //     setExam({ ...exam, examPlace: e.target.value });
          //   }}
          // />
        )}
        {examType === '2' && (
          <TextField
            sx={{ mt: 2, width: 400 }}
            id="outlined-multiline-static3"
            placeholder={t('Matn kiriting')}
            value={testResult || ''}
            multiline
            fullWidth
            size="medium"
            rows={5}
            onChange={(e) => {
              setTestResult(e.target.value);
            }}
          />
        )}
        <TextField
          sx={{ mt: 2, width: 400 }}
          id="outlined-multiline-static3"
          placeholder={t('Ariza raqamlari')}
          value={exam.applications || ''}
          multiline
          fullWidth
          size="medium"
          rows={5}
          onChange={(e) => {
            setExam({ ...exam, applications: e.target.value });
          }}
        />
        {examType !== '2' && (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={['DatePicker', 'DatePicker']}>
              <DatePicker
                format="DD.MM.YYYY"
                label="Imtihon sanasi"
                value={value}
                onChange={(newValue) => setValue(newValue)}
              />
            </DemoContainer>
          </LocalizationProvider>
        )}
        <DialogActions sx={{ p: 0, justifyContent: 'space-between', mt: 4 }}>
          <Button onClick={handleClose} variant="outlined" size="medium">
            {t('action.cancel')}
          </Button>
          <Button onClick={handleExamInformation} disabled={loading} variant="contained" autoFocus>
            {t('action.save')}
          </Button>
        </DialogActions>
      </Dialog>
      <Page title={t('applications.requests', 'Заявки на аттестацию')}>
        <Box display={'flex'} justifyContent={'space-between'} mb={3}>
          <FormControlLabel
            control={
              <Checkbox
                checked={checked}
                onChange={handleChange}
                inputProps={{ 'aria-label': 'controlled' }}
              />
            }
            label={t('MyGov.uz')}
          />
          <Box display={'flex'} alignItems={'center'}>
            {/* <TextField
              id="outlined-multiline-static4"
              placeholder={t('search')}
              rows={4}
              value={taskID || ''}
              inputProps={{ maxLength: 250 }}
              onChange={(e) => {
                setTaskID(e.target.value);
              }}
              sx={{ mr: 2 }}
              size="small"
            /> */}
            <Button variant="outlined" onClick={getMyGovApplication} sx={{ py: 1 }}>
              <CachedIcon sx={{ mr: 1 }} />
              {t("MgGov ma'lumotlarini yangilash")}
            </Button>
          </Box>
          <Button variant="outlined" onClick={handleClickOpen}>
            <HelpOutlineIcon />
            &nbsp; {t("Imtihon ma'lumotlari")}
          </Button>
        </Box>
        <>
          <Box display="flex" justifyContent={'space-between'}>
            <Button
              onClick={() => {
                setAppType('1');
              }}
              variant={'1' === activeAppType ? 'contained' : 'outlined'}
              size="large"
              color="secondary"
              sx={{ m: 1, width: '30%' }}
            >
              {t('Врачлар ва фармацевтлар')}
            </Button>
            <Button
              onClick={() => {
                setAppType('2');
              }}
              variant={'2' === activeAppType ? 'contained' : 'outlined'}
              size="large"
              color="secondary"
              sx={{ m: 1, width: '30%' }}
            >
              {t(
                '“Олий ҳамширалик иши” мутахассислигига эга бўлган ҳамширалар, ўрта тиббиёт ва ўрта фармацевтика ходимлари'
              )}
            </Button>
            <Button
              onClick={() => {
                setAppType('3');
              }}
              variant={'3' === activeAppType ? 'contained' : 'outlined'}
              size="large"
              color="secondary"
              sx={{ m: 1, width: '30%' }}
            >
              {t('Бирламчи тиббиёт ходимлари')}
            </Button>
          </Box>
          {allStatuses?.map((status, idx) => (
            <Button
              onClick={() => {
                setStatus(status);
              }}
              variant={status === activeStatus ? 'contained' : 'outlined'}
              size="small"
              color="primary"
              key={idx}
              sx={{ m: 1 }}
            >
              {t('applications.' + status.toLowerCase())}
            </Button>
          ))}
          <Button
            onClick={onDownload_STATUS_RESULTS}
            variant="contained"
            color="info"
            sx={{ p: '5px 10px', ml: 4 }}
          >
            <Download /> &nbsp;
            {t('action.download')} (Excel)
          </Button>
          <Button
            onClick={onDownload_STATUS_CSV}
            variant="contained"
            color="success"
            sx={{ p: '5px 10px', ml: 2 }}
          >
            <Download /> &nbsp;
            {t('action.download')} (CSV)
          </Button>
          {activeStatus === ApplicationStatus.CONFIRMED ? (
            <Box display={'flex'} alignItems={'center'}>
              {user?.data?.role === Roles.SUPER_ADMIN ? (
                <Box display={'flex'} alignItems={'center'}>
                  <InputFileUpload getFileValue={() => {}} field="certificates" fileName={''} />
                </Box>
              ) : null}
              {/* <Button
                onClick={onDownloadCertificates}
                variant="contained"
                color="info"
                sx={{ p: '5px 10px', ml: 4 }}
              >
                <Download /> &nbsp;
                {t('action.download')}
              </Button> */}
            </Box>
          ) : null}
          {/* CHANGE_CONFIRMED_STATUS_TEST_TAKERS */}
          {activeStatus === ApplicationStatus.CONFIRMED ? (
            <Box display={'flex'} alignItems={'center'}>
              {user?.data?.role === Roles.SUPER_ADMIN ? (
                <Box display={'flex'} alignItems={'center'}>
                  <InputFileUpload
                    getFileValue={() => {}}
                    field={'CONFIRMED_TEST_TAKERS'}
                    fileName={''}
                  />
                </Box>
              ) : null}
            </Box>
          ) : null}

          {/* CHANGE_STATUS_TEST_TAKERS_TO_OTHERS */}
          {activeStatus === ApplicationStatus.TEST_TAKERS ? (
            <Box display={'flex'} alignItems={'center'}>
              {user?.data?.role === Roles.SUPER_ADMIN ? (
                <Box display={'flex'} alignItems={'center'}>
                  <InputFileUpload
                    getFileValue={() => {}}
                    field={'TEST_TAKERS_TO_OTHERS'}
                    fileName={''}
                  />
                </Box>
              ) : null}
              {/* <Button
                onClick={onDownload_STATUS_RESULTS}
                variant="contained"
                color="info"
                sx={{ p: '5px 10px', ml: 4 }}
              >
                <Download /> &nbsp;
                {t('action.download')}
              </Button> */}
            </Box>
          ) : null}
          {/* CHANGE_STATUS_VERBAL_TO_TWICE */}
          {activeStatus === ApplicationStatus.VERBAL_PASSERS ? (
            <>
              <Box display={'flex'} alignItems={'center'}>
                {user?.data?.role === Roles.SUPER_ADMIN ? (
                  <Box display={'flex'} alignItems={'center'}>
                    <InputFileUpload
                      getFileValue={() => {}}
                      field={'VERBAL_TO_TWICE'}
                      fileName={''}
                    />
                  </Box>
                ) : null}
                {/* <Button
                  onClick={onDownload_STATUS_RESULTS}
                  variant="contained"
                  color="info"
                  sx={{ p: '5px 10px', ml: 4 }}
                >
                  <Download /> &nbsp;
                  {t('action.download')}
                </Button> */}
              </Box>
              <Box display={'flex'} alignItems={'center'}>
                {user?.data?.role === Roles.SUPER_ADMIN ? (
                  <Box display={'flex'} alignItems={'center'}>
                    <InputFileUpload
                      getFileValue={() => {}}
                      field={'VERBAL_TO_OTHER'}
                      fileName={''}
                    />
                  </Box>
                ) : null}
              </Box>
            </>
          ) : null}
          {/* CHANGE_STATUS_WHO_FAILED */}
          {activeStatus === ApplicationStatus.THOSE_WHO_FAILED_TEST ? (
            <Box display={'flex'} alignItems={'center'} mt={2}>
              {/* {user?.data?.role === Roles.SUPER_ADMIN ? (
                <Box display={'flex'} alignItems={'center'}>
                  <InputFileUpload
                    getFileValue={() => {}}
                    field={'VERBAL_TO_TWICE'}
                    fileName={''}
                  />
                </Box>
              ) : null} */}
              {/* <Button
                onClick={onDownload_STATUS_RESULTS}
                variant="contained"
                color="info"
                sx={{ p: '5px 10px', ml: 4 }}
              >
                <Download /> &nbsp;
                {t('action.download')}
              </Button> */}
            </Box>
          ) : null}
          {/* CHANGE_STATUS_DID_NOT_COME_TWICE */}
          {activeStatus === ApplicationStatus.THOSE_WHO_DID_NOT_COME_TEST_TWICE ? (
            <Box display={'flex'} alignItems={'center'} mt={2}>
              {/* {user?.data?.role === Roles.SUPER_ADMIN ? (
                <Box display={'flex'} alignItems={'center'}>
                  <InputFileUpload
                    getFileValue={() => {}}
                    field={'VERBAL_TO_TWICE'}
                    fileName={''}
                  />
                </Box>
              ) : null} */}
              {/* <Button
                onClick={onDownload_STATUS_RESULTS}
                variant="contained"
                color="info"
                sx={{ p: '5px 10px', ml: 4 }}
              >
                <Download /> &nbsp;
                {t('action.download')}
              </Button> */}
            </Box>
          ) : null}
          {/* CHANGE_STATUS_DID_NOT_COME_VERBAL_TWICE */}
          {activeStatus === ApplicationStatus.THOSE_WHO_DID_NOT_COME_VERBAL_TWICE ? (
            <Box display={'flex'} alignItems={'center'} mt={2}>
              {/* {user?.data?.role === Roles.SUPER_ADMIN ? (
                <Box display={'flex'} alignItems={'center'}>
                  <InputFileUpload
                    getFileValue={() => {}}
                    field={'VERBAL_TO_TWICE'}
                    fileName={''}
                  />
                </Box>
              ) : null} */}
              {/* <Button
                onClick={onDownload_STATUS_RESULTS}
                variant="contained"
                color="info"
                sx={{ p: '5px 10px', ml: 4 }}
              >
                <Download /> &nbsp;
                {t('action.download')}
              </Button> */}
            </Box>
          ) : null}
          {/* CHANGE_STATUS_FAILED */}
          {activeStatus === ApplicationStatus.FAILED ? (
            <Box display={'flex'} alignItems={'center'} mt={2}>
              {/* {user?.data?.role === Roles.SUPER_ADMIN ? (
                <Box display={'flex'} alignItems={'center'}>
                  <InputFileUpload
                    getFileValue={() => {}}
                    field={'VERBAL_TO_TWICE'}
                    fileName={''}
                  />
                </Box>
              ) : null} */}
              {/* <Button
                onClick={onDownload_STATUS_RESULTS}
                variant="contained"
                color="info"
                sx={{ p: '5px 10px', ml: 4 }}
              >
                <Download /> &nbsp;
                {t('action.download')}
              </Button> */}
            </Box>
          ) : null}
          {/* CHANGE_STATUS_DID_NOT_COME_VERBAL_TWICE */}
          {activeStatus === ApplicationStatus.PASSED ? (
            <Box display={'flex'} alignItems={'center'} mt={2}>
              {/* {user?.data?.role === Roles.SUPER_ADMIN ? (
                <Box display={'flex'} alignItems={'center'}>
                  <InputFileUpload
                    getFileValue={() => {}}
                    field={'VERBAL_TO_TWICE'}
                    fileName={''}
                  />
                </Box>
              ) : null} */}
              {/* <Button
                onClick={onDownload_STATUS_RESULTS}
                variant="contained"
                color="info"
                sx={{ p: '5px 10px', ml: 4 }}
              >
                <Download /> &nbsp;
                {t('action.download')}
              </Button> */}
            </Box>
          ) : null}

          <Box display={'flex'} alignItems={'center'} justifyContent={'space-around'}>
            <Box display={'flex'} alignItems={'center'} mt={5}>
              <Typography mr={5}>{t('commission')}</Typography>
              <Select
                required
                labelId="demo-simple-select2-label"
                id="demo-simple-select2"
                value={activeCommission}
                label="Age"
                sx={{ maxWidth: 500 }}
                onChange={(e: any) => {
                  setCommission(e.target.value);
                }}
              >
                <MenuItem value="0">{t('action.select')}</MenuItem>
                {commissions?.map((c: Commission, index: number) => (
                  <MenuItem value={c.id} key={index}>
                    {c.title[i18n.language as _Locale]}
                  </MenuItem>
                ))}
              </Select>
            </Box>
            {user?.data?.role !== Roles.REGION_ADMIN ? (
              <Box display={'flex'} alignItems={'center'} mt={5}>
                <Typography mr={5}>{t('region')}</Typography>
                <Select
                  required
                  labelId="demo-simple-select3-label"
                  id="demo-simple-select3"
                  value={activeRegion}
                  label="Age"
                  sx={{ maxWidth: 500 }}
                  onChange={(e: any) => {
                    setRegion(e.target.value);
                  }}
                >
                  <MenuItem value="0">{t('action.select')}</MenuItem>
                  {regions?.map((c: Region, index: number) => (
                    <MenuItem value={c.id} key={index}>
                      {c.title[i18n.language as _Locale]}
                    </MenuItem>
                  ))}
                </Select>
              </Box>
            ) : null}
            <Box display={'flex'} alignItems={'center'} mt={5} mr={5}>
              <TextField
                id="outlined-multiline-static4"
                placeholder={t('search')}
                rows={4}
                value={search || ''}
                inputProps={{ maxLength: 250 }}
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
              />
              <Button variant="contained" sx={{ py: 1.5 }} onClick={() => getApplications()}>
                <SearchIcon />
              </Button>
            </Box>
            {activeStatus === 'PASSED' || activeStatus === 'FAILED' ? (
              <Box display={'flex'} alignItems={'center'} mt={5}>
                <Typography mr={5}>{t('Steps')}</Typography>
                <Steps />
              </Box>
            ) : null}
          </Box>

          {/* <Box display={'flex'} alignItems={'center'} justifyContent={'space-around'}>
            {Object.keys(ApplicationSteps).map((step, idx) => (
              <Button
                onClick={() => {
                  // setPage(0);
                  setActiveStep(step);
                }}
                variant={step === activeStep ? 'contained' : 'outlined'}
                size="small"
                color="primary"
                key={idx}
                sx={{ m: 1 }}
              >
                {t('applications.' + step.toLowerCase())}
              </Button>
            ))}
          </Box> */}

          <BasicTable
            data={applications}
            commissions={commissions}
            specialities={specialities}
            regions={regions}
            createItem={createItem}
            changePagination={changePagination}
            total={total}
          />
        </>
      </Page>
    </>
  );
};
